import { HttpError } from "@refinedev/core";
import { AxiosError, isAxiosError } from "axios";
import { ZodError } from "zod";

export function parseValidationError(error: HttpError): string {
  return (
    error.response?.data?.error?.map((e: any) => e.ErrorMessage).join("\n") ??
    error.message ??
    "Unknown error call Cherry 🍒"
  );
}

export function parseApplicationError(error: HttpError): string {
  return error.response?.data?.detail ?? "Unknown error call Cherry 🍒";
}

/**
 * Converts any caught error into a clean, human-readable string.
 */
export function toHumanErrorMessage(error: unknown): string {
  if (!error) return "An unknown error occurred.";

  // 0. Handle zod errors
  if (error instanceof ZodError) {
    return error.message;
  }

  if (isAxiosError(error)) {
    if (!error.status) {
      return "Network error. Please check your connection to the backend.";
    }
    return error.response?.data?.message ?? error.message;
  }

  // 1. Handle standard Error objects (most common)
  if (error instanceof Error) {
    return error.message;
  }

  // 2. Handle strings thrown directly: throw "Something went wrong"
  if (typeof error === "string") {
    return error;
  }

  // 3. Handle objects that might have a message property
  if (
    typeof error === "object" &&
    "message" in error &&
    typeof error.message === "string"
  ) {
    return error.message;
  }

  // 4. Fallback for everything else (numbers, booleans, etc.)
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}
